import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { images } from "../../data/content";
export function FinalCtaSection() {
  return <section className="bg-navy px-4 py-16 text-white md:py-24" data-id="element-200" data-mp="2ii6hb37izas4">
      <div className="mx-auto max-w-3xl text-center" data-id="element-201" data-mp="2igd6rctsk6eu">
        <h2 className="text-balance font-display text-[28px] font-black uppercase leading-tight md:text-5xl" data-id="element-202" data-mp="2dj3iw1m1w2t4">
          Ready to bring more structure to your shoulder assessments?
        </h2>
        <div className="mt-6 space-y-4 text-lg leading-relaxed text-white/85" data-id="element-203" data-mp="2mktbvbvkz9t0">
          <p data-id="element-204" data-mp="318o6ixt5fo8q">
            You don’t need to keep every examination detail in your head or search through disconnected resources
            whenever you want to review a clinical concept.
          </p>
          <p data-id="element-205" data-mp="3a9cjdp6t3ik1">
            You can develop a more organized approach to gathering information, reviewing warning signs, structuring
            your examination, and developing your clinical reasoning.
          </p>
          <p data-id="element-206" data-mp="221cm48xe5ryg">I’ve brought these educational resources together into one collection so you can review them at your own pace.</p>
        </div>
        <img src={images.mockup} alt="Shoulder Assessment Blueprint collection" className="mx-auto mt-8 w-full max-w-lg" data-id="element-207" data-mp="262g2qxn9js0q" />
        <p className="mt-6 font-display text-xl font-black uppercase text-gold" data-id="element-208" data-mp="2b3lvgvgxbfa9">Shoulder Assessment Blueprint™</p>
        <p className="mt-1 font-display text-base font-extrabold uppercase" data-id="element-209" data-mp="2kzowfy01h7vm">6 comprehensive volumes + 5 specialized bonuses</p>
        <p className="mt-3 font-display text-6xl font-black text-white" data-id="element-210" data-mp="2p08wpafwsrlz">
          <span className="align-middle text-2xl text-white/70" data-id="element-211" data-mp="2ts0nnm2z8zcn">ONLY </span>$27
        </p>
        <div className="mt-8" data-id="element-212" data-mp="2yqtz78ypega6">
          <CtaButton onDark label="Yes! Give me access to the complete blueprint" sub="One-time payment · Instant digital access · Lifetime access to purchased files" data-id="element-213" data-mp="2yr3jcfx2ht7y" />
        </div>
        <p className="mt-5 flex items-center justify-center gap-2 text-sm text-brand-soft" data-id="element-214" data-mp="38pj5s5l5geb4">
          <ShieldCheckIcon className="h-4 w-4 shrink-0 text-good" aria-hidden="true" data-id="element-215" data-mp="2j1dsleqhha0i" />
          Protected by a 7-day money-back guarantee, subject to the published refund policy.
        </p>
      </div>
    </section>;
}